export { Microphone as default } from './Microphone';
